//英文
export default {
  Login: {
    Title: "Log in to your account",
    describe: "Please log in or create an account to get started.",
    Google: " Continue with Google",
    Apple: " Continue with Apple",
    or: "OR",
    Emailplaceholder: "Email address",
    Passwordplaceholder: "Password",
    Login: "Log in",
    forgot: "Forgot password?",
    notAccount: "Don't have a Fineshare account? ",
    Signup: "Sign up",
    InvalidEmail: "Invalid email format.",
    InvalidPassword: "Password should be at least 6 characters long.",
    loading: "loading..",
    login: "login",
    errorText: "Login failed, please check your username and password",
  },
  signup: {
    Title: "Create Your Account",
    describe: "Create your Fineshare account in seconds.",
    Google: " Sign up with Google",
    Apple: " Sign up with Apple",
    or: "OR",
    Emailplaceholder: "Enter email address",
    Passwordplaceholder: "Enter a 6-digit password",
    Already: "Already have an account? ",
    Login: "Log in",
    By: "By creating an account, I agree that I have read and accepted the",
    Privacy: "Privacy Policy",
    Terms: "Terms of Use.",
    and: "and",
    signupText: "Create your account",
    InvalidEmail: "Invalid email format.",
    InvalidPassword: "Password should be at least 6 characters long.",
    loading: "loading..",
    passwordError: "The email address has been registered",
    again: "You are asking too much, please try again later",
    Registration: "Registration failed, please check your email and password.",
    hasRegistered: "The email address has been registered",
  },
  Home: {
    Welcome: "Welcome to the Fineshare Account Center",
  },
};
